<template>
    <b-row :class="content.fondo" align-h="start">
        <b-col cols="12" class="pb-6 row" lg="6" >
            <div class="ml-5 mx-auto">
                <p class="benefits-titulo">Tus beneficios</p>
                <p class="benefits-subtitulo">
                    en una sola app
                </p>
                <p class="benefits-content">
                    Todos los productos, promociones y descuentos de tus marcas favoritas 
                    las encuentras en un solo lugar. Sé parte de esta nueva experiencia 
                    <span
                        class="benefits-content-resalt">GOX</span>.
                </p>
                <p class="benefits-dowload">
                    Descarga la app
                </p>

                 
                 <div class="position-dowload-icon d-sm-none d-md-block">
                    <a :href="appStoreUrl" target="_blank"><span><img src="@/assets/images/user_internal/google.png" alt="Google Store img"></span></a>
                    <a :href="appleStoreUrl" target="_blank"><span class="ml-4"><img src="@/assets/images/user_internal/store.png" alt="Apple Store img"></span></a>
                </div>

                <div class="position-dowload-icon d-lg-none socials-benefits">
                    <a :href="appStoreUrl" target="_blank"><img src="@/assets/images/user_internal/google.png" alt="Google Store img"></a>
                    <a :href="appleStoreUrl" target="_blank"><img src="@/assets/images/user_internal/store.png" alt="Apple Store img"></a>
                </div>

            </div>
        </b-col>
        <b-col cols="12" class="pb-6 d-flex justify-content-center align-items-end mx-auto" lg="6" md="6">
            <img class="benefits-imagen" src="@/assets/images/user_internal/tlf_dep.png" alt="Benefits img">
        </b-col>
    </b-row>
</template>
<script>
    import configs from '../../local_config';
    
    export default {
        name: 'section-associate',
        components: {},
        props: {
            content: Object
        },
        data: () => ({
            appStoreUrl: configs.APP_STORE_URL,
            appleStoreUrl: configs.APPLE_STORE_URL,
        })
    }
</script>
<style scoped>

@media (max-width: 600px) {
    
    .socials-benefits{
        display: none;
    }

    .benefits-titulo {
        font-size: 30px;
        text-align: left;
        padding-left: 25px;
    }

    .benefits-subtitulo {
        font-size: 30px;
        text-align: left;
        padding-left: 25px;
    }

    .benefits-content {
        padding-left: 25px;
        text-align: left;
    }

}
    
</style>